/**
 * Created by Magdalena on 20.04.2021.
 */

import React, {useEffect} from "react";
import {patient as patientPreferences, savePref} from "../../store/reducers/preferences";
import {useDispatch, useSelector} from "react-redux";
import makeStyles from '@mui/styles/makeStyles';
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import ListItemAvatar from "@mui/material/ListItemAvatar";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import Switch from "@mui/material/Switch";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import {useTranslation} from "react-i18next";
import {MenuItem, Select} from "@mui/material";
import ClearIcon from "@mui/icons-material/Clear";
import _ from "lodash";
import moment from "moment";
import Modal from "@mui/material/Modal";
import {CEIcon, InstIcon, LotIcon, ManufactureIcon, RefIcon, SaveIcon} from '../../components/icons/icons';
import AddBusinessIcon from '@mui/icons-material/AddBusiness';
import {canEnterAdminPage, hasOneOfPermission, Permissions} from '../../store/reducers/user';
import config from "../../app/config";
import IconButton from '@mui/material/IconButton';
import ImageDisplay from './imageDisplay';
import SmartView from './smartView';
import useOpenState from '../../hooks/useOpenState';
import InputLabel from '@mui/material/InputLabel';
import FormControl from '@mui/material/FormControl';
import {useHistory} from 'react-router-dom';
import PreferencesScreen from './preferencesScreen';

const useStyles = makeStyles((theme) => ({
    menu: {
        width: "min-content",
        height: "inherit",
        background: "#3D3E40"
    },
    prefView: {
        width: 400,
        height: "100%",
        backgroundColor: "white",
        color: "black !important",
        padding: 15
    },
    prefSwitch: {
        backgroundColor: "#aaa"
    },
    iconPref: {
        textAlign: 'end',
        paddingTop: 4
    },
    userName: {
        padding: "20px 10px 5px 10px",
        textAlign: "center"
    },
    userEmail: {
        padding: "0px 10px 20px 10px",
        fontSize: 10,
        textAlign: 'center'
    },
    listButton: {
        cursor: "pointer",
    },
    dropDown: {
        color: "black !important",
        border: "1px solid grey",
        borderRadius: 5,
        width: 200,
        paddingLeft: 16,
        "& MuiSelect-icon": {
            color: "black !important"
        }
    },
    colorBox: {
        padding: 12,
        borderBottom: "1px solid #dcd8d8",
        marginBottom: 10,
        display: "flex",
        alignItems: "center"
    },
    selectorItemFormControl: {
        width: "90%",
    },
    // selectorItemSelect: {
    //     width: "100%",
    //     fontSize: "80%",
    //     marginTop: "9px !important",
    // },
    selectorItemLabel: {
        fontSize: "80%",
    },
    dropDownIcon: {
        color: "black !important"
    },
    modalBody: {
        background: "white",
        color: "black",
        width: "60%",
        left: "20%",
        position: "absolute",
        top: "30px",
        padding: "20px",
        height: "90%",
        overflow: "auto",
        fontSize: "13px",
        borderRadius: "6px"
    },
    modalIcon: {
        fontSize: 38
    },
    textGridItem: {
        display: "flex",
        alignItems: "center",
        marginBottom: 10
    },
    iconGridItem: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        marginBottom: 10
    },
    icon: {
        cursor: "pointer"
    },
    selectorItemSelect: {
        width: "100%",
        marginTop: "9px !important",
        color: "black !important",
        maxHeight: 200,
        overflow: 'auto'
    },
}));

function UserMenu(props) {
    const classes = useStyles();
    const { t, i18n } = useTranslation();
    const dispatch = useDispatch();
    const history = useHistory();
    const authObject = window.keycloak ? window.keycloak : window.auth;
    const [prefView, setPrefView] = React.useState(false);
    const [aboutView, setAboutView] = React.useState(false);
    const [displayPrefView, setDisplayPrefView] = React.useState(false);
    const [isSmartViewModalOpen, openSmartViewModal, closeSmartViewModal] = useOpenState(false, true);

    const openPref = () => {
        setPrefView(!prefView);
    };
    const openAbout = () => {
        if(prefView) setPrefView(false);
        setAboutView(!aboutView);
    }

    const goToAdmin = () => {
        history.push('/admin');
    }

 //   let iconPref = openTabName === "pref" ? <ChevronLeftIcon/>: <ChevronRightIcon /> ;

    const getTabIcon = (name) => {
        return openTabName === name ? <ChevronLeftIcon/>: <ChevronRightIcon /> ;
    }

    const logOut = () => {
        authObject.logout();
    };
    const [user, setUser] = React.useState(null);

    useEffect(() => {
        if(!user && props.open) {
            authObject.loadUserInfo().then(value => {
                setUser(value);
            });
        }
    },[props.open]);

    const [openTabName, setOpenTabName] = React.useState(null);

    const handleOpenTab = (name) => {
        if(openTabName === name)  setOpenTabName(null)
        else setOpenTabName(name)
    }
    return (
        <div className={classes.menu + " user-menu-grid"}>
            <span>
                <span>
                    { user && <div>
                        <div className={classes.userName}> { user.name } </div>
                        <div className={classes.userEmail}> { user.email } </div>
                    </div>}
                </span>
            <List className={classes.root}>

                {/* FIXME: Add Theme selector! */}
                {/* <ListItem>
                    <ListItemText primary="Theme:" secondary="Dark" />
                </ListItem> */}
                <ListItem onClick={()=> handleOpenTab("pref")} className={classes.listButton}>
                    <ListItemText primary="Preferences"/>
                    <ListItemAvatar classes={{root: classes.iconPref}}>
                        {getTabIcon("pref")}
                    </ListItemAvatar>
                </ListItem>
                <ListItem onClick={() => setDisplayPrefView(true)} className={classes.listButton}>
                    <ListItemText primary={t('Image Display')}/>
                </ListItem>
                  <ListItem onClick={()=> handleOpenTab("smartView")} className={classes.listButton}>
                    <ListItemText primary={t('Smart View')}/>
                       <ListItemAvatar classes={{root: classes.iconPref}}>
                        {getTabIcon("smartView")}
                    </ListItemAvatar>
                </ListItem>
                {dispatch(canEnterAdminPage()) &&  <ListItem onClick={goToAdmin} className={classes.listButton}>
                    <ListItemText primary={t('Admin')}/>
                </ListItem>
                }
                  <ListItem onClick={openAbout} className={classes.listButton}>
                    <ListItemText primary={t('About Eyonix')}/>
                </ListItem>
                <ListItem onClick={logOut} className={classes.listButton}>
                    <ListItemText primary={t('Sign out')}/>
                </ListItem>
            </List>
            </span>

            {openTabName === "pref" && <PreferencesScreen/>}

            {aboutView &&
                <Modal open={aboutView}
                       onClose={ openAbout }>
                    <div className={classes.modalBody}>
                        <div className={classes.modalContentView}>
                            <Grid container>
                                <Grid item xs={2} className={classes.iconGridItem}>
                                    <CEIcon className={classes.modalIcon}/>
                                </Grid>
                                <Grid item xs={10} className={classes.textGridItem}>
                                    CE Mark (developed in compliance with Directive 93/42/EEC for Class I devices). Made in the United Kingdom
                                </Grid>
                                <Grid item xs={2} className={classes.iconGridItem}>
                                    <RefIcon className={classes.modalIcon}/>
                                </Grid>
                                <Grid item xs={10} className={classes.textGridItem}>
                                    Eyonix R1
                                </Grid>
                                <Grid item xs={2} className={classes.iconGridItem}>
                                    <LotIcon className={classes.modalIcon}/>
                                </Grid>
                                <Grid item xs={10} className={classes.textGridItem}>
                                {t(`Version ${config.version || 2.0}`)}
                                </Grid>
                                <Grid item xs={2} className={classes.iconGridItem}>
                                    <InstIcon className={classes.modalIcon}/>
                                </Grid>
                                <Grid item xs={10} className={classes.textGridItem}>
                                    Please read this instruction manual thoroughly before using the device
                                </Grid>
                                <Grid item xs={2} className={classes.iconGridItem}>
                                    <ManufactureIcon className={classes.modalIcon}/>
                                </Grid>
                                <Grid item xs={10} className={classes.textGridItem}>
                                    SoftJump Ltd
                                    <br/>
                                    25 Moorgate, London, England, EC2R 6AY
                                </Grid>
                            </Grid>
                            <br/>
                                <div>
                                    This device fulfils the provisions of the European Commission (EC) Directive 93/42/EEC (Medical Devices Directive)
                                </div>
                            <br/>
                                <div>
                                    This device has been developed under the strict quality system of SoftJump Ltd.
                                </div>
                            <br/>
                                <div>
                                    This software product has been designed according to:
                                    <br/>
                                    <br/>
                                    <b>ISO 13485:2016 </b>
                                    <br/>
                                    Medical devices – Quality Management Systems – Requirements for regulatory purposes
                                    <br/>
                                    <br/>

                                    <b> DCB0129:2018 </b>
                                    <br/>
                                    Application of clinical safety risk management to the manufacture of health IT systems
                                    <br/>
                                    <br/>

                                    <b> DCB0160:2018 </b>
                                    <br/>
                                    Clinical Risk Management: its Application in the Deployment and Use of Health IT Systems
                                    <br/>
                                    <br/>

                                    <b> IEC 62304:2006
                                        <br/>
                                        Amd 1:2015</b>
                                    <br/>
                                    Medical device software – Software lifecycle processes
                                    <br/>
                                    <br/>

                                    <b>ISO 15233-1:2012 </b>   <br/>
                                    Medical Devices: Symbols to be used with medical device labels, labelling and information to be supplied - Part 1: General requirements
                                    <br/>
                                    <br/>

                                    <b>ISO 14971:2012</b>
                                    <br/>
                                    Medical Devices - Application of risk management to medical devices
                                </div>
                            <br/>
                            <div style = {{textDecoration: "underline"}}> DICOM conformance statement available on request</div>
                            <br/>
                            <div style = {{}}> <b>Revision:</b> {t(process.env.GIT)}</div>

                        </div>
                    </div>
                </Modal> }

            {displayPrefView && <ImageDisplay onClose={() => {setDisplayPrefView(false)}}/>}
            {openTabName === "smartView" && <SmartView onClose={closeSmartViewModal}/> }
        </div>
    );

}

export default UserMenu;